<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div></div>
</template>
<script lang="js">

import {impersonateService} from './services';
import router from '@/plugins/vue-router';
import store from '@/store';

export default  {
  name: 'Impersonate',
  mounted () {
    if(this.$route.query['access'] && this.$route.query['refresh']) {
      const data = {access_token: this.$route.query['access'], refresh_token: this.$route.query['refresh']}
      impersonateService.validateTokens(data).then(() => {
          store.commit('account/setLoggedIn');
          store.commit('account/setImpersonate');
          router.router.push('/', Function);
      }).catch(() => {router.router.push('/login', Function);});
    } else {
      router.router.push('/login', Function);
    }
  }
}
</script>
